export default __webpack_public_path__ + "static/media/new-zealand.acab3be4.png";